<template>
  <div class="material-symbols-rounded" style="color: red">home</div>

  <div class="about">
    <h1>This is an about page</h1>
    <h3>Usuario: {{ userName }} Id: {{ usuarioId }} Rol:{{ rolId }}</h3>
  </div>
</template>

<script setup>
import { getUser } from "@/utils/auth";
const userName = getUser().usuario; 
const usuarioId = getUser().id;
const rolId = getUser().rol;
</script>
